<template>
  <button class="btn" :class="{'disabled': disabled, 'icon-only': !action}" :disabled="disabled">
    <slot/>
    <span v-if="action">{{action}}</span>
  </button>
</template>

<script>
export default {
    props: ["action", "disabled", "isLoading", "iconOnly"]
};
</script>

<style lang="less">
@import (reference) "~@/assets/less/general.less";
@button-active-text: @white;
@button-active-bg: @blue-mid;
@button-active-border: @blue-mid;
@button-active-bg-hover: @blue-middark;
@button-active-border-hover: @blue-middark;

@button-primary-text: @blue-mid;
@button-primary-bg: @white;
@button-primary-border: @white;
@button-primary-bg-hover: @white;
@button-primary-border-hover: @white;

@button-secondary-text: @gray-middark;
@button-secondary-bg: fade(@white, 0%);
@button-secondary-border: @gray-midlight;
@button-secondary-bg-hover: fade(@gray-light, 50%);
@button-secondary-border-hover: @gray-light;

@button-optional-text: @bluegray-dark;
@button-optional-bg: @gray-extralight;
@button-optional-border: @gray-light;
@button-optional-bg-hover: @gray-light;
@button-optional-border-hover: @bluegray-light;

@button-disabled-text: @gray-midlight;
@button-disabled-bg: @gray-extralight;
@button-disabled-border: @gray-extralight;
@button-disabled-bg-hover: @gray-extralight;
@button-disabled-border-hover: @gray-extralight;

@button-fault-text: @pink-mid;
@button-fault-bg: fade(@pink-mid, 10%);
@button-fault-border: transparent;
@button-fault-bg-hover: fade(@pink-mid, 22%);
@button-fault-border-hover: transparent;

@btn-height: 100px;
@btn-border-radius: 10px;
@btn-small-height: 70px;
@btn-small-border-radius: 6px;

@btn-padding-large: 100px;
@btn-padding-small: 10px;
@btn-small-padding-large: 17px;
@btn-small-padding-small: 5px;
@btn-padding-icon: 7px;
@btn-small-padding-icon: 12px;

.btn {
    .lh-display(flex);
    .lh-align-items(center);
    .lh-transition(all 0.3s cubic-bezier(0, 0.5, 0.5, 1));
    height: @btn-height;
    line-height: @btn-height - 2px;
    border-radius: @btn-border-radius;
    padding: 0 @btn-padding-large;
    position: relative;
    .fontsize-xl;
    .font-bold;
    .pointer;

    &:not(:last-child) {
        margin-bottom: 30px;
    }

    // Default: primary
    .btn.primary;

    .ico {
        .size-32;
    }

    > span {
        white-space: nowrap;
        margin: 0 auto;
    }

    &.icon-only {
        padding: 0 @btn-padding-small 0 @btn-padding-small;

        .ico {
            margin-left: 0;
            margin-right: 0;
        }

        &.small,
        &.secondary {
            padding: 0 @btn-small-padding-small 0 @btn-small-padding-small;
        }
    }

    &.inline {
        display: inline-block;
        vertical-align: middle;

        .ico {
            margin-top: -4px;
        }

        &:not(:only-child):not(:last-child) {
            margin-right: 8px;
        }
    }
}

// Extra classes
.btn.small {
    .fontsize-l;
    .font-bold;
    height: @btn-small-height;
    line-height: @btn-small-height - 2px;
    border-radius: @btn-small-border-radius;
    padding: 0 @btn-small-padding-large;

    .ico {
        margin-top: (@btn-small-height - @btn-height) / 2 + 1px; // 2 = border
    }
}

.btn.primary {
    color: @button-primary-text;
    background-color: @button-primary-bg;
    border: 1px solid @button-primary-border;

    &:hover {
        background-color: @button-primary-bg-hover;
        border: 1px solid @button-primary-border-hover;
    }

    .ico {
        .fill-color(@white);
    }
}

.btn.secondary {
    .btn.small;
    color: @button-secondary-text;
    background-color: @button-secondary-bg;
    border: 1px solid @button-secondary-border;

    span {
        height: 30px;
    }

    &:hover {
        background-color: @button-secondary-bg-hover;
        border: 1px solid @button-secondary-border-hover;
    }

    .ico {
        .fill-color;
    }
}

.btn.optional {
    .btn.small;

    color: @button-optional-text;
    background-color: @button-optional-bg;
    border: 1px solid @button-optional-border;

    &:hover {
        background-color: @button-optional-bg-hover;
        border: 1px solid @button-optional-border-hover;
    }

    .ico {
        .fill-color;
    }
}

.btn.disabled {
    color: @button-disabled-text;
    background-color: @button-disabled-bg;
    border: 1px solid @button-disabled-border;

    &:hover {
        background-color: @button-disabled-bg;
        border: 1px solid @button-disabled-border;
    }

    &,
    span {
        cursor: default;
    }

    .ico {
        .fill-color(@button-disabled-text);
    }
}

.btn.fault {
    color: @button-fault-text;
    background-color: @button-fault-bg;
    border: 1px solid @button-fault-border;

    &:hover {
        background-color: @button-fault-bg-hover;
        border: 1px solid @button-fault-border-hover;
    }

    .ico {
        .fill-color(@button-fault-text);
    }
}
</style>
